if (!customElements.get('wish-list-button')) {
    class WishListButton extends HTMLElement {
        constructor() {
            super();
            this.meta = meta;
            this.isAdded = false;
            this.notification = this.querySelector('wish-list-notification');
            this.setupEventForButton();
        }

        /**
         * @returns {string[]}
         */
        static get observedAttributes() {
            return ['product-id', 'product-variant-id'];
        }

        // noinspection JSUnusedGlobalSymbols
        connectedCallback() {
            if (!this.rendered) {
                this.init();
            }
        }

        // noinspection JSUnusedGlobalSymbols
        attributeChangedCallback() {
            this.init();
        }

        setupData() {
            this.data = {
                productId: parseInt(this.getAttribute('product-id')),
                variantId: parseInt(this.getAttribute('product-variant-id')),
            };
        }

        init() {
            this.setupData();
            this.themeLoaded((swat) => {
                this.swat = swat;
                this.swatData = SwymProductVariants[this.data.variantId];

                if (!this.swatData) {
                    this.swatData = {
                        empi: this.data.productId,
                        epi: this.data.variantId
                    };
                }

                this.render();
            });

            this.rendered = true;
        }

        /**
         * @param addedCallBack
         * @param removedCallBack
         */
        wishListLoader(addedCallBack, removedCallBack) {
            this.swat.fetch((list) => {
                let isInWishList = list.find((item) => {
                    return item.empi === this.data.productId && item.epi === this.data.variantId;
                })

                if (isInWishList) {
                    addedCallBack();
                } else {
                    removedCallBack();
                }
            });
        }

        /**
         * @param callback
         */
        themeLoaded(callback) {
            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }

            window.SwymCallbacks.push((swat) => {
                callback(swat);
            });
        }

        render() {
            this.wishListLoader(() => {
                this.setWishListAdded();
            }, () => {
                this.setWishListRemoved();
            });
        }

        setupEventForButton() {
            this.addEventListener('click', () => {
                if (this.isAdded) {
                    this.swat.removeFromWishList(this.swatData, () => {
                        this.setWishListRemoved();
                        this.newEventForUpdateStatus();
                    });
                } else {
                    this.swat.addToWishList(this.swatData, () => {
                        this.setWishListAdded();
                        this.showNotificationAdded();
                        this.newEventForUpdateStatus();
                    });
                }

                this.reCheck();
            });

            // Apply only product detail
            this.setupEventForProductDetail();
        }

        setupEventForProductDetail() {
            if (this.meta.page.resourceType === 'product') {
                const variantElements = document.querySelectorAll('[name="id"]');

                variantElements.forEach((variantElement) => {
                    variantElement.addEventListener('change', (e) => {
                        let variantId = e.target.value;
                        this.setAttribute('product-variant-id', variantId);

                        if (this.meta.product && this.meta.product.variants) {
                            let variantSelected = this.meta.product.variants.find((variant) => {
                                return parseInt(variantId) === variant.id;
                            });

                            this.notification.hide();
                            this.notification.modifyContent({
                                name: variantSelected.name,
                                image: this.swatData.iu
                            });
                        }
                    });
                });
            }
        }

        /**
         * Re-check all wishListButton
         * In case there is more than 1 button on the same page, the state will be synchronized.
         */
        reCheck() {
            let wishListOther = document.querySelectorAll(`[product-variant-id="${this.data.variantId}"]`);
            if (wishListOther) {
                wishListOther.forEach((button) => {
                    if (button !== this) {
                        setTimeout(() => {
                            button.setAttribute('product-variant-id', this.data.variantId.toString());
                        }, 2000);
                    }
                });
            }
        }

        showNotificationAdded() {
            if (this.notification) {
                this.notification.show();
            }
        }

        setWishListAdded() {
            this.isAdded = true;
            this.classList.remove('added');
            this.classList.add('removed');
        }

        setWishListRemoved() {
            this.isAdded = false;
            this.classList.add('added');
            this.classList.remove('removed');
        }

        newEventForUpdateStatus() {
            this.dispatchEvent(new CustomEvent("changeStatus", { bubbles: true }));
        }
    }

    customElements.define('wish-list-button', WishListButton);
}